export const believeData = [
  {
    id: '1',
    title: 'Верим, что все мы&nbsp;разные',
    description: 'Для этого наша команда разрабатывает различные авторские чекапы',
    icon: '/images/about/atom.png',
  },
  {
    id: '2',
    title: 'Верим в&nbsp;диагностику без переплат',
    description: 'Все чекапы проработаны ведущими профильными врачами',
    icon: '/images/about/wallet.png',
  },
  {
    id: '3',
    title: 'Верим в&nbsp;экономию вашего времени',
    description: 'Экономия времени кардинально меняет ваш образ жизни',
    icon: '/images/about/time.png',
  },
];
